<template>
  <div>
    <header class="mdn-Menu mdn-Menu--logged header-portal-container">
      <div class="mdn-Menu-top">
        <div class="mdn-Menu-container">
          <nav class="mdn-Menu-top-content">
            <ul
              class="mdn-Menu-top-list w-100 justify-space-around justify-sm-end justify-lg-end"
            >
              <li
                class="mdn-Menu-top-list-item mdn-Menu-top-list-item-accessibility align-self-center p-0 pr-sm-4"
              >
                <a
                  v-if="!getIsMeli && !isLoading"
                  href="https://www.claro.com.br/celular/flex"
                  target="_blank"
                  >Ir para claro.com.br</a
                >
              </li>
              <li
                class="mdn-Menu-top-list-item mdn-Menu-top-list-item-accessibility"
              >
                <AccessibilityButton />
              </li>
              <li
                class="mdn-Menu-top-list-item mdn-Menu-top-list-item-accessibility"
              >
                <LibrasButton />
              </li>
              <li
                class="mdn-Menu-top-list-item mdn-Menu-top-list-item-accessibility"
              >
                <ContrastButton />
              </li>
              <li
                class="mdn-Menu-top-list-item mdn-Menu-top-list-item-accessibility"
              >
                <ZoomButton @openModal="showZoomModal()" />
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div class="mdn-Menu-main border-shadow" v-if="!isLoading">
        <div class="mdn-Menu-container">
          <nav class="mdn-Menu-content">
            <div class="mdn-Menu-content-left">
              <a
                v-if="!getIsMeli"
                class="mdn-Menu-logo-link"
                href="mdn-Menu-logo-event"
                title="Click e confira a página"
              >
                <img
                  class="mdn-Menu-logo"
                  src="https://mondrian.claro.com.br/brands/horizontal/inverse/claro-flex.svg"
                  alt="Logo da Claro"
                />
              </a>
              <img
                v-if="getIsMeli"
                class="mdn-Menu-logo"
                src="https://mondrian.claro.com.br/brands/horizontal/inverse/claro-flex.svg"
                alt="Logo da Claro"
              />
            </div>
          </nav>
        </div>
      </div>
    </header>
    <Dialog
      :show-modal="showModal"
      title=""
      :description="String($t('modalMessages.baseZoomModal.description'))"
      button-text="Ok"
      :show-button-close="false"
      :show-header="false"
      bottons-position="left"
      is-dialog-type="warning"
      @isClose="closeModalAlert()"
      @buttonConfirmation="closeModalAlert()"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";

import { Component } from "vue-property-decorator";
import Dialog from "@/components/common/Dialog/index.vue";
import { Action, Getter } from "vuex-class";
import { ActionMethod } from "vuex";
import ContrastButton from "./components/ContrastButton/index.vue";
import AccessibilityButton from "./components/AccessibilityButton/index.vue";
import LibrasButton from "./components/LibrasButton/index.vue";
import ZoomButton from "./components/ZoomButton/index.vue";

@Component({
  name: "Header",
  components: {
    Dialog,
    ContrastButton,
    ZoomButton,
    AccessibilityButton,
    LibrasButton,
  },
})
export default class Header extends Vue {
  @Action setTheme!: ActionMethod;
  @Getter getIsMeli!: string[];

  showModal = false;
  isLoading = true;

  get detectMob() {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
    ];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  created() {
    setTimeout(() => {
      this.isLoading = false;
    }, 3000);
  }

  showZoomModal(): void {
    const win = window as any;
    if (this.$gtm.enabled()) {
      win.dataLayer.push({
        event: "event",
        eventCategory: "claro-flex:home",
        eventAction: "clique:link",
        eventLabel: "acessibilidade:zoom",
      });
    }
    this.showModal = true;
  }

  closeModalAlert() {
    this.showModal = false;
  }
}
</script>

<style lang="scss" scoped>
.mdn-Menu-top-list-item.mdn-Menu-top-list-item-accessibility #zoom-btn {
  height: 100%;
}

.mdn-Menu-top-list-item.mdn-Menu-top-list-item-accessibility {
  display: block;
}

.mdn-Menu-top-content {
  padding: 0 20px;
}

.header-portal-container {
  height: 108px;
  z-index: 999999999;

  @media (min-width: 980px) {
    height: 134px;
  }

  .border-shadow {
    box-shadow: 0px 4px 8px -4px rgba(0, 0, 0, 0.08);
  }
}

@media (max-width: 520px) {
  .mdn-Menu-content {
    display: flex;
    justify-content: center;

    .mdn-Menu-logo {
      height: 2rem;
    }
  }
}
</style>
